import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { Alert, Box, Button, Container, Grid, Typography } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';

import PageTitle from "components/PageTitle";
import { FormTextField } from "components/FormInputs";

export default function NoteAddPage() {

  const navigate = useNavigate();

  const [isDebtorNotFound, setIsDebtorNotFound] = useState(false);
  const [isAddSuccessed, setIsAddSuccessed] = useState(false);
  const [noteId, setNoteId] = useState(null);

  const schema = yup.object().shape({
    noteName: yup.string().required("노트명을 입력해주세요."),
    debtor: yup.string().required("대상 유저의 ID를 입력해주세요")
  });

  const {
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const addNote = (formData) => {
    axios.post("/api/note/group/add", formData)
    .then(res => {
      if (res.data.code === "success") {
        setNoteId(res.data.noteId);
        setIsAddSuccessed(true);
      } else if (res.data.code === "debtor_not_found") {
        setIsDebtorNotFound(true);
      }
    })
    .catch(err => {
      alert("등록에 실패하였습니다.");
    })
  }

  return (
    <Container>
      <PageTitle>📘&nbsp;노트 생성</PageTitle>

      {!isAddSuccessed ?
        <Grid container flexDirection="column" gap="16px">
          {isDebtorNotFound &&
            <Alert severity="error" onClose={() => setIsDebtorNotFound(false)}>대상 유저 ID와 일치하는 회원을 찾을 수 없습니다.</Alert>
          }

          <FormTextField
            label="노트명"
            name="noteName"
            control={control}
          />

          <FormTextField
            label="대상 유저 ID"
            name="debtor"
            control={control}
          />

          <Button variant="contained" onClick={handleSubmit(addNote)}>생성</Button>
        </Grid>
        :
        <Grid container flexDirection="column" alignItems="center" sx={{color: "gray"}}>
          <CheckIcon sx={{fontSize: "3rem", marginBottom: "4px"}}/>
          <Typography fontSize={"1.25rem"} marginBottom="32px">노트가 생성되었습니다.</Typography>

          <Box sx={{display: "flex", gap: "8px"}}>
            <Button variant="outlined" onClick={() => navigate("/")}>홈으로</Button>
            <Button variant="outlined" onClick={() => navigate(`/note/${noteId}`)}>노트로 이동</Button>
          </Box>
        </Grid>
    }
    </Container>
  );
}